module.exports = __webpack_public_path__ + "img/donation.2898a04c.svg";